module.exports = __webpack_public_path__ + "media/images/Vector-41f133ccafb952208ecafc817f56247d.png";